export const environment = {
  production: false,

  API_SERVER: 'https://infra-digital-st.dgrmsalta.gov.ar/api',

  // WebSocket configuration
  WEBSOCKET_URL: 'wss://infra-digital-st.dgrmsalta.gov.ar',

  //DESA MACROCLICK
  API_MACROCLICK_DOCKER: 'https://pmacroclick-dev-2.dgrmsalta.gov.ar/infracciones/api',
  //API_MACROCLICK_DOCKER: 'http://localhost:3005/api',
  CRYPTO_SECRET: 'b7b42273ff4b03c6857989dbb3d9eb9765866867e7ddf5b98c7ef0b34a4c874d',

  COMERCIO: 'InfraccionesOran',

  recaptchaSiteKey: '6LdaMKorAAAAAN1cZbms2VYMZ_zK5rADay3iO5BP',
  recaptchaSiteKeyV2: '6LeUH10tAAAAAONW8IAfn6YPmvQfy9byo2_H_aFb', // TODO: completar con la site key v2 (checkbox) de este ambiente
  TIMEOUT_INACTIVITY: 30 * 60 * 1000, // 30 minutos en milisegundos
};
